export default {"breakpoint":{},"theme":{"themes":{"light":{"primary":"#db064c","secondary":"#161414","warning":"#D0A030","error":"#C16061","success":"#76C55F"}}}}
